import { DateTime, Duration } from 'luxon';
export const duration = (seconds) => {
    return Duration.fromObject({ seconds }).toFormat('hh:mm:ss');
};
export const formatTime = (iso8601) => {
    return DateTime.fromISO(iso8601).toFormat('HH:mm');
};
const time = {
    duration,
    formatTime,
};
export default time;
